export default {
  shoname (state) {
    return state.ager
  },
  shownames (state) {
    return state.num
  }
}
